import Vue from "vue";
import Vuex from "vuex";
import pathify from "vuex-pathify";

import { Firebase, initFirebase } from "@/services/firebase.js";

import VuexEasyFirestore from "vuex-easy-firestore";

import ui from "./modules/ui";
import lists from "./modules/lists";
import user from "./modules/user";
import tasks from "./modules/tasks";
import team from "./modules/team";
import project from "./modules/project";
import listLibrary from "./modules/list-library";
import taskLibrary from "./modules/task-library";
import teamListsLibrary from "./modules/team-lists-library";
import teamTasksLibrary from "./modules/team-tasks-library";

const easyFirestore = VuexEasyFirestore(
  [
    lists,
    tasks,
    team,
    project,
    taskLibrary,
    listLibrary,
    teamListsLibrary,
    teamTasksLibrary,
  ],
  {
    logging: true,
    FirebaseDependency: Firebase,
  }
);

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    ui,
  },
  plugins: [pathify.plugin, easyFirestore],
});

initFirebase()
  .catch((error) => {
    // take user to a page stating an error occurred
    // (might be a connection error, or the app is open in another tab)
  })
  .then(() => {
    Firebase.auth().onAuthStateChanged((user) => {
      store.dispatch("user/fetchUser", user);
    });
  });

export default store;
